import { TileSizes } from '@ad-lucy/components/layout/Grid/TileSizeContext';
import type { GridInterface } from '@ad-lucy/context/adData/contentData/types';
import { BREAKPOINT_DISPLAY_NAME, BREAKPOINT_VALUE } from '@ad-lucy/grid-breakpoints';

import { defineGrid } from './defineGrid';

export const gridFx2x0 = (): GridInterface[] =>
  defineGrid('F:2:0', [
    {
      name: BREAKPOINT_DISPLAY_NAME.SITEBAR,
      breakpoint: BREAKPOINT_VALUE.SITEBAR,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 2,
              spanCol: 2,
              fullSize: true,
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
              justifySelf: 'end',
            },
            {
              tileId: 2,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
              justifySelf: 'start',
            },
          ],
        },
      ],
    },
    {
      name: 'HPA 1/2',
      breakpoint: BREAKPOINT_VALUE.HPA,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 2,
              fullSize: true,
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
              justifySelf: 'center',
            },
          ],
        },
      ],
    },
    {
      name: 'HPA 2/2',
      breakpoint: BREAKPOINT_VALUE.HPA,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 2,
              fullSize: true,
            },
          ],
        },
        {
          columns: [
            {
              tileId: 2,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
              justifySelf: 'center',
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 1/2',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 2,
              fullSize: true,
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 2/2',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      rows: [
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
            },
          ],
        },
        {
          columns: [
            {
              tileId: 2,
              tileSize: TileSizes['400x400'],
              aspectRatio: '1 / 1',
            },
          ],
        },
      ],
    },
  ]);
